import * as Integrations from "@sentry/integrations";

/*
 * Load various JavaScript modules.
 */
window.axios = require("axios");
window._ = require("lodash");
window.moment = require("moment");
window.Promise = require("promise");
window.swal = require("sweetalert2");

window.toastr = require("../../assets/js/plugins/toastr.js").default;

if (process.env.NODE_ENV === "production") {

    window.Sentry = require("@sentry/browser");

    window.Sentry.init({
        dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
        integrations: [new Integrations.Vue({Vue: window.Vue, attachProps: true})]
    });
}

/*
 * Define Moment locales
 */
window.moment.defineLocale("en-short", {
    parentLocale: "en",
    relativeTime: {
        future: "in %s",
        past: "%s",
        s: "1s",
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "1d",
        dd: "%dd",
        M: "1 month ago",
        MM: "%d months ago",
        y: "1y",
        yy: "%dy"
    }
});
window.moment.locale("en");

/*
 * Load jQuery and Bootstrap jQuery, used for front-end interaction.
 */
if (window.$ === undefined || window.jQuery === undefined) {
    window.$ = window.jQuery = require("jquery");
}

require("jquery-slimscroll");
require("./vendor/waves");
require("sticky-kit/dist/sticky-kit.min");
require("./vendor/custom");
require("./vue-bootstrap");
require("bootstrap");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": App.csrfToken
};

/**
 * Intercept the incoming responses.
 *
 * Handle any unexpected HTTP errors and pop up modals, etc.
 */
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    // Handle network or connection errors
    if (!error.response) {
        if (error.code === "ECONNABORTED") {
            console.log("Request timed out. Check your internet connection.");
        } else if (error.message.includes("Network Error")) {
            console.log("Request failed. Check your internet connection.");
        }

        return error;
    }

    switch (error.response.status) {
        case 401:
            window.axios.get("/logout");
            $("#modal-session-expired").modal("show");
            break;

        case 402:
            let title = "You're not signed up";
            let text = "Complete your subscription to start using RedRabbit!";

            if (error.response.message && error.response.message.contains("Consider upgrading")) {
                title = "Consider upgrading to a premium account";
                text = error.response.message;
            }

            swal({
                title: title,
                text: text
            });
            break;

        case 403:
            toastr.error("You do not have permission to perform this action.");
            break;

        case 500:
            toastr.error("We couldn't process your request, please try again later. " + error.response.data.message);
            if (error.response.data.rejectPromise) {
                return Promise.reject(error);
            }
            break;

        default:
            return Promise.reject(error);

    }

});

// Pusher Set-up
require("pusher-js");
import Echo from "laravel-echo";

window.pusherKey = process.env.MIX_PUSHER_APP_KEY;

